import {useDevice} from 'platform/foundation';

import {prop} from 'ramda';

import type {DashboardVehicleResponseBody} from '@dms/api/core';

import {DASHBOARD_TILE_NATURAL_ROWS} from '../../consts/dashboardTileNaturalRows';
import {DASHBOARD_TILE_ROW_COLUMNS} from '../../consts/dashboardTileRowColumns';
import {DASHBOARD_TILE_ROW_SPACING} from '../../consts/dashboardTileRowSpacing';
import {DashboardTileSize} from '../../types/DashboardTileSize';
import {DashboardTileRows} from '../DashboardTileRows/DashboardTileRows';
import {LatestVehicleItem} from './LatestVehicleItem';

interface LatestVehicleRowsProps {
  vehicles: DashboardVehicleResponseBody[];
  size: DashboardTileSize;
  isPreview?: boolean;
  naturalRows?: number;
}

export function LatestVehicleRows(props: LatestVehicleRowsProps) {
  const device = useDevice();
  const effectiveSize = device === 'mobile' ? 'half' : props.size;

  return (
    <DashboardTileRows
      id="latest-vehicles"
      rows={props.vehicles}
      getRowKey={(vehicle) => vehicle.id}
      getRowLayoutKey={(vehicle) => JSON.stringify(vehicle)}
      renderRow={(vehicle, options) => (
        <LatestVehicleItem
          vehicle={vehicle}
          isProbe={options.isProbe}
          isPreview={props.isPreview}
        />
      )}
      naturalRows={props.naturalRows ?? DASHBOARD_TILE_NATURAL_ROWS}
      spacing={DASHBOARD_TILE_ROW_SPACING}
      columns={prop(effectiveSize, DASHBOARD_TILE_ROW_COLUMNS)}
    />
  );
}
